import React from 'react';
import { MapPin, Navigation, Car, Building, TreePine, CheckCircle2 } from 'lucide-react';
import { locationFeatures } from '../data/mock';

const LocationSection = () => {
  return (
    <section id="location" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm tracking-wider uppercase mb-4 block">
            Strategic Location
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Prime Georgetown Address
          </h2>
          <p className="text-slate-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Positioned at the intersection of growth and opportunity, Stadium Plaza Center
            offers unparalleled visibility and access in one of Texas's fastest-growing communities.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Map Placeholder / Location Visual */}
          <div className="relative">
            <div className="aspect-square bg-slate-100 rounded-3xl overflow-hidden shadow-xl">
              {/* Google Maps Embed - 510 Stadium Drive, Georgetown, TX */}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3440.2!2d-97.7089!3d30.6338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644d19e8c5a5a5a%3A0x0!2s510+Stadium+Dr%2C+Georgetown%2C+TX+78628!5e0!3m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Stadium Plaza Center Location"
                className="grayscale hover:grayscale-0 transition-all duration-500"
              />
            </div>
            
            {/* Address Card Overlay */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-2xl p-6 border border-slate-100 max-w-xs">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-emerald-600" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Stadium Plaza Center</h4>
                  <p className="text-slate-600 text-sm">510 Stadium Drive</p>
                  <p className="text-slate-600 text-sm">Georgetown, TX 78628</p>
                </div>
              </div>
            </div>
          </div>

          {/* Location Features */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-8">
              Why This Location?
            </h3>
            
            {/* Feature List */}
            <div className="space-y-4 mb-10">
              {locationFeatures.map((feature, index) => (
                <div key={index} className="flex items-center gap-4">
                  <CheckCircle2 className="text-emerald-500 flex-shrink-0" size={22} />
                  <span className="text-slate-700">{feature}</span>
                </div>
              ))}
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: Navigation, label: 'From I-35', value: '3 min' },
                { icon: Building, label: 'To Downtown', value: '8 min' },
                { icon: Car, label: 'Traffic Count', value: '25K+ Daily' },
                { icon: TreePine, label: 'Population Growth', value: '+15% YoY' }
              ].map((stat, index) => (
                <div key={index} className="bg-slate-50 rounded-xl p-5 hover:bg-emerald-50 transition-colors group">
                  <stat.icon className="text-slate-400 group-hover:text-emerald-500 mb-3 transition-colors" size={24} />
                  <div className="text-2xl font-bold text-slate-900 mb-1">{stat.value}</div>
                  <div className="text-slate-500 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
